import React from "react";
import { DisplayText, TextStyle } from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import step3 from "../../assets/welcome_3.webp"
const Step3 = () => {
  const connectToPayPal = () => {
    let params = {
      action: "connectToPayPal",
    };
    callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        // window.top.location..urlhref = res.data.url;
        window.open(res.data.url, "connect paypal", "width=500,height=500");
      }
    });
  };
  return (
    <div className="tab-pane">
      <div className="panel-heading pb-4 text-center">
        <DisplayText size="medium">Process Your Old Orders</DisplayText>
      </div>
      <div className="panel-body">
        <div className="text-center">
          <img
            style={{ width: "80%" }}
            src={step3}
            alt="Responsive image"
          />
          <DisplayText size="medium">
            Do you want to sync old orders to PayPal?
          </DisplayText>
          <p className="text-center mt-4" style={{ fontSize: "16px" }}>
            <TextStyle variation="subdued">
              Please check the option below, let SyncTrack handle the rest.
            </TextStyle>
          </p>
          <div className="text-center mt-4"></div>
        </div>
      </div>
    </div>
  );
};

export default Step3;
